import { FaWhatsapp } from "react-icons/fa6";
import { FiArrowUpRight } from "react-icons/fi";

const WorkStatus = () => {
  return (
    <div className="px-3.5 py-3 border-t border-white/[0.08] bg-[#1C1E20]">
      <a
        href="https://wa.me/8801974238487"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between w-full px-3 py-2.5 rounded-lg bg-[#24272c] hover:bg-[#22D4FD]/10 border border-[#22D4FD]/30 hover:border-[#22D4FD] text-gray-300 hover:text-white transition-all duration-300 group shadow-[0_0_10px_rgba(34,212,253,0.08)] hover:shadow-[0_0_16px_rgba(34,212,253,0.25)]"
      >
        <span className="flex items-center gap-2.5 text-[13px] font-medium tracking-wide">
          <FaWhatsapp className="text-[#22D4FD] text-base group-hover:scale-110 transition-transform" />
          <span className="group-hover:text-[#22D4FD] transition-colors">
            Connect via WhatsApp
          </span>
        </span>
        <FiArrowUpRight className="text-gray-400 group-hover:text-[#22D4FD] text-xs group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
      </a>
    </div>
  );
};

export default WorkStatus;
